import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { auth } from '../firebase';
import { Field, Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import {  ModalBody } from 'react-bootstrap';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { useState } from 'react';
import MYProgressBar from './Progressbar';



function CreateAccount(props) {

  const navigate=useNavigate();


  const[pbar,startpbar]=useState(false);
  const [error,seterror]=useState()
    const handlesubmit= async (values)=>{
        console.log("values",values)
        console.log("lenth",values.password.length)
        startpbar(true)
        if(values.password.length>=8){
          startpbar(true);
          seterror("");
          if(values.password===values.confirmpass){
        await createUserWithEmailAndPassword(auth,values.email,values.confirmpass).then(
            (usercredetial)=>{
              console.log(usercredetial.user)
                return updateProfile(usercredetial.user,{
                  displayName: values.username,
                }).then(()=>{
                  //usercredetial.user.displayName=values.username
                  //const myuser=usercredetial.user
                  navigate('/Home')
                })
               
            })
            .catch((error)=>{
                console.log("my error",error)
               // const errorCode = error.code;
                const errorMessage = error.message;
                startpbar(false);
                seterror("Email All Ready in Use");
                console.log(errorMessage);
            })
          }else{
            startpbar(false)
            seterror("Password and Confirm Password Not Matched")
          }
          }else{
           startpbar(false)
            seterror("Password Must be Eight Chracters")
          }
    }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
     
      {/* <marquee classname="text-center" behaviour="alternate" width="250"><h2>Create Account</h2></marquee><hr  color='pink'></hr> */}
     
    
      
        <ModalBody  style={{backgroundImage: 'url(https://mdbcdn.b-cdn.net/img/Photos/new-templates/search-box/img4.webp)'}}>
          <h2 className="text-uppercase text-center mb-5">Create an account</h2>
          <Formik initialValues={{username:"",email:"",password:"",confirmpass:""}} onSubmit={handlesubmit}>
         {({values,setFieldValue})=>(
         <Form className="myform_width mx-auto">
          <Field  onChange={e=>{
            e.preventDefault() ;
            const {value}=e.target
            setFieldValue("username",value)

          }} name='username' required placeholder='Please Enter Your Name' class="form-control m-2"  type='text' />
          <Field onChange={e=>{
            e.preventDefault() ;
            const {value}=e.target
            setFieldValue("email",value)

          }}  name='email' required placeholder='Please Enter Your Email id' class="form-control m-2" type='email' />
          <Field onChange={e=>{
            e.preventDefault() ;
            const {value}=e.target
            setFieldValue("password",value)

          }}  name='password' required placeholder='Please Enter Password' min="8" class="form-control m-2" type='password' />
          <Field onChange={e=>{
            e.preventDefault() ;
            const {value}=e.target
            setFieldValue("confirmpass",value)

          }}  name='confirmpass' required placeholder='Please Enter Confirm Password' min="8" class="form-control m-2 col-2" type='password' />
        
          <div className='d-flex flex-row justify-content-center mb-4'>
            
          
            <input type='checkbox'/>
            <label>
             I agree all statements in Terms of service
            </label>
            
          </div>
          <div className='text-center'>
           {
            pbar===false ?
            <button name='submit'  class="btn btn-primary text-center btn-lg" >Register</button>
            :
            <MYProgressBar 
              now="100"
              label="Creating Account Please Wait"
            />
           }
            <div className='text-danger' style={{fontSize:"20px"}}>{error}</div>
            </div>
       
          </Form>
                )}
          </Formik>
        </ModalBody>
  
  
     
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
export default CreateAccount;